import React, { useState, useEffect, useRef } from 'react';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Select from '@material-ui/core/Select';
import TextField from "@material-ui/core/TextField";
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Slide from '@material-ui/core/Slide';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Switch from '@material-ui/core/Switch';
import { makeStyles } from '@material-ui/core/styles';
import ButtonLoad from 'react-bootstrap-button-loader';
import LoadingOverlay from 'react-loading-overlay';
import BeatLoader from 'react-spinners/BeatLoader';
import $ from 'jquery';
import { withNamespaces } from 'react-i18next';
import i18next from 'i18next';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapLocationDot } from "@fortawesome/pro-duotone-svg-icons";

import { sortLocationByCode } from '@actions/punch/location';
import { sortProjectByCode, filterProjectCCQ } from '@actions/punch/project';
import { sortCcqJobTitleByCode } from '@actions/punch/ccqJobTitle';
import { sortDepartmentByCode } from '@actions/punch/department';
import { paramPayment } from '@actions/timesheet/paramPayment';
import { addCCQPunch, loadCombosCCQ } from '@actions/timesheet';

import { IsEnglish } from '@utils/language';
import * as storage from '@utils/storage';
import * as statusCode from '@scripts/StatusCode';
import styles from '@styles/punch.module.css';
import AlertAlgo from '@components/controls/AlertSnack';
import PunchGeolocation from '@components/punchCCQ/PunchGeolocation';

const useStyles = makeStyles((theme) => ({
    appBar: {
        backgroundColor: 'var(--color1) !important',
        color: 'var(--color2) !important'
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    buttonSection: {
        paddingBottom: '0px!important'
    },
    form: {
        paddingBottom: '0px!important'
    },
    divLoading: {
        marginTop: '3px'
    },
    warningGeolocation: {
        backgroundColor: '#ff7b7b',
        color: '#ffffff',
        padding: '10px'
    },
    buttons: {
        textAlign: 'center'
    }
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export function PunchCCQForm(props) {
    const classes = useStyles();
    const alertRef = useRef(null);
    const onClose = props.onClose;

    const [listComplete, setListComplete] = useState({});
    const [locations, setLocations] = useState([]);
    const [projects, setProjects] = useState([]);
    const [projectsReg, setProjectsReg] = useState([]);
    const [projectsCCQ, setProjectsCCQ] = useState([]);
    const [projectsAll, setProjectsAll] = useState([]);
    const [ccqJobTitles, setCCQJobTitles] = useState([]);
    const [jobTitles, setJobTitles] = useState([]);
    const [departments, setDepartments] = useState([]);
    const [location, setLocation] = useState(0);
    const [project, setProject] = useState('');
    const [ccqJobTitle, setCCQJobTitle] = useState('');
    const [jobTitle, setJobTitle] = useState('');
    const [department, setDepartment] = useState('');
    const [comments, setComments] = useState('');
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [isActive, setIsActive] = useState(true);
    const [openGeolocation, setOpenGeolocation] = useState(false);
    const [currentPosition, setCurrentPosition] = useState(null);
    const [currentZone, setCurrentZone] = useState(null);
    const [activeLocationID, setActiveLocationID] = useState(null);
    const [activePunchID, setActivePunchID] = useState(null);
    const [isActivePunch, setIsActivePunch] = useState(false);
    const [openDetail, setOpenDetail] = useState(false);
    const [dataDetail, setDataDetail] = useState([]);
    const [linkProjectPActivity, setLinkProjectPActivity] = useState(false);
    const [isPostCompleted, setIsPostCompleted] = useState(true);
    const [isCCQ, setIsCCQ] = useState(storage.getIsCCQ());
    const [useCCQ, setUseCCQ] = useState(storage.getIsCCQ());

    const [paramPay, setParamPay] = useState({});
    const [defaultValues, setDefaultValues] = useState({});

    const [geolocationParam, setGeolocationParam] = useState({});
    const [geolocationInfo, setGeolocationInfo] = useState(null);

    const [punchTime, setPunchTime] = useState(false);

    useEffect(() => {
        loadParamPay();
    }, []);

    useEffect(() => {
        if (Object.keys(paramPay).length > 0) {
            loadGeolocationParam();
        }
    }, [paramPay]);

    useEffect(() => {
        if (Object.keys(geolocationParam).length > 0) {
            loadGeolocationInfo();
        }
    }, [geolocationParam]);

    useEffect(() => {
        if (geolocationInfo && Object.keys(geolocationInfo).length > 0) {
            loadLists();

            const pos = {
                lat: geolocationInfo.latitude,
                lng: geolocationInfo.longitude
            };
            setCurrentPosition(pos);
        }
    }, [geolocationInfo]);

    useEffect(() => {
        if (Object.keys(listComplete).length > 0) {
            loadLocations();
            loadCCQJobTitles();
            loadJobTitles();
            loadDepartments();
            resizeForm();
            setIsActive(false);
            setLoading(false);
        }
    }, [listComplete]);

    useEffect(() => {
        if (Object.keys(locations).length > 0) {
            loadPayProject();
        }
    }, [locations]);

    const loadParamPay = () => {
        paramPayment().then((result) => {
            const param = JSON.parse(result.param);
            const param2 = {};
            const defaults = {};

            param2.companyPayProject = param.projectPay;
            param2.companyPayActivity = param.activityPay;
            param2.companyDepartment = param.department;
            param2.companyJobTitle = param.jobTitle;
                
            setParamPay(param2);

            defaults.defaultProjectPay = param.defaultProjectPay;
            defaults.defaultActivityPay = param.defaultActivityPay;
            defaults.defaultTaskPay = param.defaultTaskPay;
            defaults.defaultDepartment = param.defaultDepartment;
            defaults.defaultJobTitle = param.defaultJobTitle;

            setDefaultValues(defaults);
        });
    }

    const loadGeolocationParam = () => {
        const geolocation = {};

        geolocation.useGeolocation = storage.getUseGeolocation();
        geolocation.useGeolocationZone = storage.getUseGeolocationZone();
        geolocation.useGeolocationMandatory = storage.getUseGeolocationMandatory();
        setGeolocationParam(geolocation);
        setPunchTime(storage.getPunchTime());
    }

    const loadGeolocationInfo = async () => {
        const geolocation = {};
        geolocation.latitude = 0;
        geolocation.longitude = 0;
        geolocation.isGeolocationAvailable = false;
        geolocation.isGeolocationEnabled = false;
        geolocation.coords = false;

        if (geolocationParam.useGeolocation) {
            if ("geolocation" in navigator) {
                geolocation.isGeolocationAvailable = true;

                const successCallback = (position) => {
                    geolocation.latitude = position.coords.latitude;
                    geolocation.longitude = position.coords.longitude;
                    geolocation.isGeolocationEnabled = true;
                    geolocation.coords = true;

                    setGeolocationInfo(geolocation);
                }

                const errorCallback = () => {
                    setGeolocationInfo(geolocation);
                    setIsActive(false);
                }

                navigator.geolocation.getCurrentPosition(successCallback, errorCallback, { timeout: 10000 });
            }
            else {
                setGeolocationInfo(geolocation);
                setIsActive(false);
            }
        }
        else {
            setGeolocationInfo(geolocation);
        }
    }

    const loadLists = async () => {
        const list = await loadCombosCCQ(location, geolocationInfo.latitude, geolocationInfo.longitude, geolocationInfo.isGeolocationEnabled);

        const data = JSON.parse(list.result);

        setListComplete(data);
    }

    const loadLocations = async () => {
        const list = listComplete.locations;

        if (!list || list.length <= 0) {
            setLoading(geolocationInfo.isGeolocationEnabled && geolocationParam.useGeolocation && geolocationParam.useGeolocationZone);
            loadPayProject();
        }
        else {
            const defaultLocation = list[0].geolocationId;
            setLocations(sortLocationByCode(list));
            setLocation(activeLocationID != null ? activeLocationID : defaultLocation);

            let zone;
            const locationValidator = activeLocationID != null ? activeLocationID : defaultLocation;

            for (var i = 0; i < locations.length; i++) {
                if (locations[i].geolocationId === locationValidator) {
                    zone = locations[i].Zone;
                    break;
                }
            }

            if (zone != null) {
                setCurrentZone(JSON.parse(zone));
            }
        }
    }

    const loadPayProject = async () => {
        if (paramPay.companyPayProject) {
            const list = !listComplete || !listComplete.projectsP ? [] : sortProjectByCode(listComplete.projectsP);
            const listReg = filterProjectCCQ(list, "N");
            const listCCQ = filterProjectCCQ(list, "O");
            const listToUse = (useCCQ ? listCCQ : list);

            let defaultProject;

            if (listComplete.employee != null && listComplete.employee.numProjectDef?.length > 0) {
                defaultProject = listComplete.employee.numProjectDef;
            } else {
                defaultProject = defaultValues.defaultProjectPay
                    ? defaultValues.defaultProjectPay : '';
            }


            setProjectsAll(list);
            setProjectsReg(listReg);
            setProjectsCCQ(listCCQ);
            setProjects(listToUse);
            setProject(project ? project : defaultProject);
        }
    }

    const loadCCQJobTitles = async () => {
        const list = listComplete.ccqJobTitles;

        const defaultJobTitle = list.length == 1 ? list[0].ccqFunctionId : '';

        setCCQJobTitles(!list ? [] : sortCcqJobTitleByCode(list));
        setCCQJobTitle(ccqJobTitle ? ccqJobTitle : defaultJobTitle);
    }

    const loadJobTitles = async () => {
        const list = listComplete.jobTitles;

        const defaultJobTitle = defaultValues.defaultJobTitle
            ? defaultValues.defaultJobTitle
            : list && list.length == 1 ? list[0].jobCode : '';

        setJobTitles(!list ? [] : sortCcqJobTitleByCode(list));
        setJobTitle(jobTitle ? jobTitle : defaultJobTitle);
    }

    const loadDepartments = async () => {
        const list = listComplete.departments;

        const defaultDepartment = defaultValues.defaultDepartment
            ? defaultValues.defaultDepartment
            : list && list.length == 1 ? list[0].departmentCode : '';

        setDepartments(!list ? [] : sortDepartmentByCode(list));
        setDepartment(department != '' ? department : defaultDepartment);
    }

    const resizeForm = async () => {
        setTimeout(() => {
            const height = window.innerHeight;
            const titleBar = $('#appBarTitle').height();
            const header = $('div[data-id=headerPunch]').height();
            const heightMenuFavorite = document.querySelector('#menuFavorite').clientHeight;
            const geoWarning = document.querySelector('#divGeoWarning')?.clientHeight ?? 0;

            const customHeight = height - header - titleBar - heightMenuFavorite - geoWarning;

            const element = document.querySelector('#divPunchRoot');

            if (element !== undefined && element !== null) {
                element.style.height = `${customHeight}px`;
            }
        }, 1000);
    }

    const onChangeProject = (event) => {
        setProject(event.target.value);
    }

    const onChangeCCQJobTitle = (event) => {
        setCCQJobTitle(event.target.value);
    }

    const onChangeJobTitle = (event) => {
        setJobTitle(event.target.value);
    }

    const onChangeDepartment = (event) => {
        setDepartment(event.target.value);
    }

    const onChangeComments = (event) => {
        setComments(event.target.value);
    }

    const onChangeLocation = (event) => {
        let zone = null;

        if (locations != null) {
            for (var i = 0; i < locations.length; i++) {
                if (locations[i].geolocationId === event.target.value) {
                    zone = locations[i].Zone;
                    break;
                }
            }
            
            if (zone != null) {
                setCurrentZone(JSON.parse(zone));
            }
        }

        setLocation(event.target.value);
    }

    const onChangeUseCCQ = (event) => {
        setUseCCQ(event.target.checked);

        setProjects(event.target.checked ? projectsCCQ : projectsAll);
    }

    const validateForm = () => {
        return new Promise((resolve) => {
            let message = '';
            let error = false;

            if (Object.keys(locations).length > 0 && !location) {
                message = i18next.t('punch:message.location-form');
                error = true;
            }
            else if (paramPay.companyPayProject && !project) {
                message = i18next.t('punch:message.project-form');
                error = true;
            }
            else if ((paramPay.companyJobTitle) && ((useCCQ && !ccqJobTitle) ||
                !useCCQ && !jobTitle)) {
                message = i18next.t('punchCCQ:message.jobTitle-form');
                error = true;
            }
            else if (paramPay.companyDepartment && !department) {
                message = i18next.t('punchCCQ:message.department-form');
                error = true;
            }

            if (error) {
                setLoading(false);
                setIsPostCompleted(true);
                showMessageError(message);

                resolve(false);
            }
            else {
                resolve(true);
            }
        })
    }

    const showMessageError = (msg) => {
        if (alertRef && alertRef.current) {
            alertRef.current.showMessageError(msg);
        }
    }

    const showMessageWarning = (msg) => {
        if (alertRef && alertRef.current) {
            alertRef.current.showMessageWarning(msg);
        }
    }

    const showMessageSuccess = (msg) => {
        if (alertRef && alertRef.current) {
            alertRef.current.showMessageSuccess(msg);
        }
    }

    const handleButtonClick = () => {
        if (!loading) {
            setSuccess(false);
            setLoading(true);
            setIsPostCompleted(false);

            const currentDate = new Date();
            const punchTime = currentDate.getFullYear() + "/" + (currentDate.getMonth() + 1) + "/" + currentDate.getDate() + " " + currentDate.getHours() + ":" + currentDate.getMinutes();

            validateForm().then(isValid => {
                if (isValid) {
                    addCCQPunch(punchTime, location, project, ccqJobTitle, jobTitle, department, comments, geolocationInfo.latitude, geolocationInfo.longitude, true, useCCQ)
                        .then((response) => {
                            if (response == undefined || response.status == statusCode.STATUS_INTERNALSERVERERROR) {
                                showMessageError(i18next.t('error:generic-error'));
                                setIsPostCompleted(true);
                                setLoading(false);

                                return;
                            }

                            const result = response;

                            if (result.codeReturn == 999) {
                                showMessageWarning(i18next.t('punch:limitTimeClientError'));
                                setLoading(false);
                                setIsPostCompleted(true);
                            }
                            else if (result.codeReturn < 0) {
                                showMessageWarning(result.message);
                                setSuccess(true);
                                setLoading(false);
                                setIsPostCompleted(true);
                            }
                            else {
                                setSuccess(true);
                                setLoading(false);
                                setIsPostCompleted(true);
                                onClose();
                                showMessageSuccess(result.message);
                            }
                        }).catch(error => {
                            showMessageWarning('erro');
                        });
                }
            });
        }
    }

    const handleButtonGeolocationClick = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
                const geolocation = {};
                geolocation.latitude = position.coords.latitude;
                geolocation.longitude = position.coords.longitude;
                geolocation.isGeolocationAvailable = geolocationInfo.isGeolocationAvailable;
                geolocation.isGeolocationEnabled = geolocationInfo.isGeolocationEnabled;
                geolocation.coords = geolocationInfo.coords;

                setGeolocationInfo(geolocation);
                setOpenGeolocation(true);
            })
        }
    };

    const handleCloseGeolocation = (event) => {
        setOpenGeolocation(false);
    }

    return (
        geolocationInfo == null ? '' :

        (!geolocationInfo.isGeolocationAvailable && geolocationParam.useGeolocationMandatory)
            ? <div>{i18next.t('geolocation:message.error-support')}</div>
            : (!geolocationInfo.isGeolocationEnabled && geolocationParam.useGeolocationMandatory)
                ? <div className={classes.warningGeolocation}>{i18next.t('geolocation:message.error-enabled')}</div>
                : <LoadingOverlay
                    className={classes.divLoading}
                    active={isActive || (geolocationInfo.isGeolocationEnabled && !geolocationInfo.coords && geolocationParam.useGeolocation)}
                    spinner={<BeatLoader />}
                    text={(geolocationInfo.isGeolocationEnabled && !geolocationInfo.coords && geolocationParam.useGeolocation) ? i18next.t('geolocation:message.load') : i18next.t('punch:form.loading')}
                >
                    {geolocationInfo.isGeolocationEnabled != undefined && !geolocationInfo.isGeolocationEnabled && geolocationParam.useGeolocation &&
                        <div id="divGeoWarning" className={classes.warningGeolocation}>{i18next.t('geolocation:message.error-enabled')}</div>
                    }
                    <div className={styles.rootPunch}>
                        <div id="divPunchRoot" className={styles.punchCCQFormWrapper}>
                            {
                                <div data-id="divPunch" className={styles.divPunchForm}>
                                    <form className={classes.form}>
                                        {isCCQ && (
                                            <FormControl className={styles.switchComponent} fullWidth>
                                                <FormControlLabel
                                                    control={
                                                        <Switch
                                                            checked={useCCQ}
                                                            onChange={onChangeUseCCQ}
                                                            name="useCCQ"
                                                            variant="success"
                                                        />
                                                    }
                                                    label={i18next.t("punchCCQ:form.useCCQ")}
                                                    labelPlacement="start"
                                                />
                                            </FormControl>
                                        )}

                                        {geolocationInfo.isGeolocationEnabled && geolocationParam.useGeolocation && geolocationParam.useGeolocationZone && (
                                            <FormControl fullWidth>
                                                <div className={styles.divFormSelect}>
                                                    <InputLabel id="label-location">{i18next.t('punch:form.location')}</InputLabel>
                                                    <Select
                                                        labelId="label-location"
                                                        id="location"
                                                        value={location}
                                                        onChange={onChangeLocation}
                                                        disabled={isActivePunch || punchTime}
                                                        fullWidth
                                                    >
                                                        {locations.map((obj, index) =>
                                                            <MenuItem key={index} className={styles.selectItem} value={obj.geolocationId}>{`${obj.geolocationCode} - ${IsEnglish() ? obj.descriptionE : obj.descriptionF}`}</MenuItem>
                                                        )}
                                                    </Select>
                                                </div>
                                            </FormControl>
                                        )}

                                        {paramPay.companyPayProject && (
                                            <FormControl fullWidth>
                                                <div className={styles.divFormSelect}>
                                                    <InputLabel id="label-project">{i18next.t('punch:form.project')}</InputLabel>
                                                    <Select
                                                        labelId="label-project"
                                                        id="project"
                                                        value={project || ''}
                                                        onChange={onChangeProject}
                                                        disabled={isActivePunch || punchTime}
                                                    >
                                                        {projects.map((obj, index) =>
                                                            <MenuItem key={index} className={styles.selectItem} value={obj.project}>{`${obj.project} - ${IsEnglish() ? obj.projectEn : obj.projectFr}`}</MenuItem>
                                                        )}
                                                    </Select>
                                                </div>
                                            </FormControl>
                                        )}

                                        {(useCCQ && (
                                            <FormControl fullWidth>
                                                <div className={styles.divFormSelect}>
                                                    <InputLabel id="label-ccqJobTitle">{i18next.t('punchCCQ:form.ccqJobTitle')}</InputLabel>
                                                    <Select
                                                        labelId="label-ccqJobTitle"
                                                        id="ccqJobTitle"
                                                        value={ccqJobTitle || ''}
                                                        onChange={onChangeCCQJobTitle}
                                                        disabled={isActivePunch || punchTime}
                                                    >
                                                        {ccqJobTitles.map((obj, index) =>
                                                            <MenuItem key={index} className={styles.selectItem} value={obj.ccqFunctionId}>{`${obj.ccqFunctionId} - ${IsEnglish() ? obj.descriptionE : obj.descriptionF}`}</MenuItem>
                                                        )}
                                                    </Select>
                                                </div>
                                            </FormControl>
                                        )) || (
                                            <FormControl fullWidth>
                                                <div className={styles.divFormSelect}>
                                                    <InputLabel id="label-jobTitle">{i18next.t('punchCCQ:form.jobTitle')}</InputLabel>
                                                    <Select
                                                        labelId="label-jobTitle"
                                                        id="jobTitle"
                                                        value={jobTitle || ''}
                                                        onChange={onChangeJobTitle}
                                                        disabled={isActivePunch || punchTime}
                                                    >
                                                        {jobTitles.map((obj, index) =>
                                                            <MenuItem key={index} className={styles.selectItem} value={obj.jobCode}>{`${obj.jobCode} - ${IsEnglish() ? obj.jobDescriptionEnglish : obj.jobDescriptionFrench}`}</MenuItem>
                                                        )}
                                                    </Select>
                                                </div>
                                            </FormControl>
                                        )}

                                        <FormControl fullWidth>
                                            <div className={styles.divFormSelect}>
                                                <InputLabel id="label-department">{i18next.t('punchCCQ:form.department')}</InputLabel>
                                                <Select
                                                    labelId="label-department"
                                                    id="department"
                                                    value={department || ''}
                                                    onChange={onChangeDepartment}
                                                    disabled={isActivePunch || punchTime}
                                                >
                                                    {departments.map((obj, index) =>
                                                        <MenuItem key={index} className={styles.selectItem} value={obj.departmentCode}>{`${obj.departmentCode} - ${IsEnglish() ? obj.descriptionE : obj.descriptionF}`}</MenuItem>
                                                    )}
                                                </Select>
                                            </div>
                                        </FormControl>

                                        <FormControl fullWidth>
                                            <TextField
                                                id="comments"
                                                label={i18next.t('punch:form.comments')}
                                                multiline
                                                minRows={4}
                                                className={styles.inputComments}
                                                onChange={onChangeComments}
                                                value={comments}
                                            />
                                        </FormControl>

                                        <FormControl className={classes.buttons}>
                                            <ButtonLoad
                                                loading={!isPostCompleted}
                                                className={styles.punchButton}
                                                disabled={loading}
                                                onClick={handleButtonClick}
                                                variant="success"
                                            >
                                                {i18next.t('punch:button.punch')}
                                            </ButtonLoad>
                                            {geolocationInfo.isGeolocationEnabled && geolocationParam.useGeolocation && <Button
                                                className={styles.punchGeolocation}
                                                color="primary"
                                                disabled={loading}
                                                onClick={handleButtonGeolocationClick}
                                                endIcon={<FontAwesomeIcon icon={faMapLocationDot} />}
                                            >
                                                {i18next.t('punch:button.map')}
                                            </Button>}
                                        </FormControl>

                                        <Dialog fullScreen open={openGeolocation} onClose={handleCloseGeolocation} TransitionComponent={Transition}>
                                            <AppBar className={classes.appBar}>
                                                <Toolbar>
                                                    <IconButton edge="start" color="inherit" onClick={handleCloseGeolocation} aria-label="close">
                                                        <CloseIcon />
                                                    </IconButton>
                                                    <Typography variant="h6" className={classes.title}>
                                                        {i18next.t('punch:button.map')}
                                                    </Typography>
                                                </Toolbar>
                                            </AppBar>
                                            <PunchGeolocation currentPosition={currentPosition} currentZone={currentZone} />
                                        </Dialog>
                                    </form>
                                </div>
                            }
                            <AlertAlgo ref={alertRef} />
                        </div>
                    </div>
                </LoadingOverlay>
    )
}

export default withNamespaces(['punch', 'punchCCQ', 'geolocation', 'error'], { wait: true })(PunchCCQForm);